import { render, staticRenderFns } from "./HomeMediaCoverage.vue?vue&type=template&id=22795855&scoped=true&"
import script from "./HomeMediaCoverage.vue?vue&type=script&lang=js&"
export * from "./HomeMediaCoverage.vue?vue&type=script&lang=js&"
import style0 from "./HomeMediaCoverage.vue?vue&type=style&index=0&id=22795855&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22795855",
  null
  
)

export default component.exports